import ModalConfirmLeave from "Components/ModalConfirmLeave";
import Page from "Containers/Page";
import {
  SpacingVertical,
  Tooltip,
  ToastContainer,
} from "mailup-web-components";
import type { FC } from "react";
import React, { useEffect } from "react";
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from "recoil";
import Header from "./components/Header";
import UploadFile from "./components/Step1UploadFile/UploadFile";
import WizardContainer from "./components/WizardContainer";
import WizardStepButtons from "./components/WizardStepButtons";
import { WizardSteps } from "./model";
import {
  importFileIsDirtyState,
  importFileWizardStepState,
} from "./recoil/state/state";
import { getImportFilesCallback, resetPageCallback } from "./recoil/callbacks";
import Preview from "./components/Step2Preview/Preview";
import FieldsAssociation from "./components/Step3FieldAssociation/FieldsAssociation";
import Settings from "./components/Step4Settings/Settings";
import CopyPasteStep from "./components/StepCopyPaste/CopyPasteStep";
import { useParams } from "react-router-dom";
import { pageState } from "State/page";

const ImportWizard: FC = () => {
  const getImportFiles = useRecoilCallback(getImportFilesCallback, []);
  const resetPage = useRecoilCallback(resetPageCallback, []);
  const step = useRecoilValue(importFileWizardStepState);
  const importFileIsDirty = useRecoilValue(importFileIsDirtyState);
  const setStep = useSetRecoilState(importFileWizardStepState);
  const setPageState = useSetRecoilState(pageState);
  const { type } = useParams();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    init();
    return () => {
      resetPage();
    };
  }, []);

  const init = () => {
    if (type === "copyandpaste") {
      setStep(WizardSteps.CopyPaste);
      setPageState((prev) => ({
        ...prev,
        status: "ready",
      }));
    } else {
      getImportFiles(true);
    }
  };

  return (
    <>
      <Tooltip />
      <ToastContainer />
      <Header />
      <ModalConfirmLeave isDirty={importFileIsDirty} />
      <Page onReload={init}>
        <WizardContainer />
        <SpacingVertical />
        {type === "file" && (
          <>
            {step === WizardSteps.UploadFile && <UploadFile />}
            {step === WizardSteps.Preview && <Preview />}
            {step === WizardSteps.DynimicFields && <FieldsAssociation />}
          </>
        )}
        {type === "copyandpaste" && step === WizardSteps.CopyPaste && (
          <CopyPasteStep />
        )}
        {step === WizardSteps.GroupsAndSettings && <Settings />}
        <WizardStepButtons />
      </Page>
    </>
  );
};

export default ImportWizard;
